'use strict';

(function () {
  'use strict';

  angular.module('msTracker').controller('DisclaimerModalCtrl', DisclaimerModalCtrl);

  DisclaimerModalCtrl.$inject = ['$timeout', 'activityRouter', 'requirements', 'user', 'close'];

  /* @ngInject */
  function DisclaimerModalCtrl($timeout, activityRouter, requirements, user, close) {
    var $ctrl = this;
    $ctrl.title = 'DisclaimerModalCtrl';
    $ctrl.user = user;
    $ctrl.tags = _.flatMap(requirements, function (r) {
      return r.data.tags;
    }).map(function (r) {
      return r.shortName;
    });
    $ctrl.navigateAction = function (activity) {
      $ctrl.closeModal();
      // Give the modal time to close, wait 300ms + 20ms just to be safe.
      $timeout(function () {
        activityRouter.createTrain(activity);
      }, 320);
    };
    $ctrl.closeModal = function () {
      // 300ms pause to let ngAnimate hide the modal.
      close(false, 300);
    };
  }
})();